"use strict";

import angular from "angular";

import template from "./donut-chart-monitoring.component.html";
import "./donut-chart-monitoring.component.scss";

import Highcharts from "highcharts";

require("highcharts/highcharts-more")(Highcharts);

class DonutChartMonitoringComponent {
    constructor() {
        this.id = "_" + Math.random().toString(36).substr(2, 9);
        this.titleText = "";
    }

    $onInit() {
        this._calculateValues();
    }

    _chartRender() {
        this.chart = new Highcharts.Chart(this.id, {
            chart: {
                type: "pie"
            },
            title: {
                text: ""
            },
            subtitle: {
                text: this.titleText,
                align: "center",
                verticalAlign: "middle",
                style: { fontSize: "20px" },
                y: 20
            },
            plotOptions: {
                pie: {
                    innerSize: "60%"
                },
                series: {
                    dataLabels: {
                        enabled: false
                    }
                }
            },
            exporting: { enabled: false },
            tooltip: {
                enabled: false
            },
            series: [
                {
                    data: this.data
                }
            ],
            credits: {
                enabled: false
            }
        });
    }

    _calculateValues() {
        if (this.type === "audit") this._calculateAuditValues();
        if (this.type === "health") this._calculateHealthValues();
    }

    _calculateAuditValues() {
        const total = this.critical + this.notFired;
        let titleText = "";

        if (this.critical)
            titleText += `<span style='color: #D60436'>${this.critical}</span>`;

        if (this.notFired)
            titleText += `/<span style='color: #C4C4C4'>${this.notFired}</span>`;

        if (titleText[0] === "/") titleText = titleText.substring(1);

        this.titleText = titleText;

        const criticalPercentage = (100 * this.critical) / total;
        const notFiredPercentage = (100 * this.notFired) / total;

        this.data = [
            {
                name: "Não Disparados",
                y: notFiredPercentage,
                color: "#C4C4C4"
            },
            {
                name: "Disparados",
                y: criticalPercentage,
                color: "#D60436"
            }
        ];

        setTimeout(() => this._chartRender(), 500);
    }

    _calculateHealthValues() {
        const total = this.bad + this.good + this.notFired;

        let titleText = "";

        if (this.good)
            titleText += `<span style='color: #00D2D9'>${this.good}</span>`;

        if (this.bad)
            titleText += `/<span style='color: #D500FF'>${this.bad}</span>`;

        if (this.notFired)
            titleText += `/<span style='color: #C4C4C4'>${this.notFired}</span>`;

        if (titleText[0] === "/") titleText = titleText.substring(1);

        this.titleText = titleText;

        const badPercentage = (100 * this.bad) / total;
        const goodPercentage = (100 * this.good) / total;
        const notFiredPercentage = (100 * this.notFired) / total;

        this.data = [
            {
                name: "Não Disparados",
                y: notFiredPercentage,
                color: "#C4C4C4"
            },
            {
                name: "Limite Mínimo",
                y: badPercentage,
                color: "#D500FF"
            },
            {
                name: "Objetivo",
                y: goodPercentage,
                color: "#00D2D9"
            }
        ];

        setTimeout(() => this._chartRender(), 500);
    }
}

export { DonutChartMonitoringComponent };

DonutChartMonitoringComponent.$inject = [];

const name = "donutChartMonitoringComponent";
const def = {
    bindings: {
        type: "<",
        critical: "<",
        notFired: "<",
        bad: "<",
        good: "<"
    },
    controller: DonutChartMonitoringComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
